module.exports = __webpack_public_path__ + "img/makeitcheaper.59bf7778.svg";